import { ProfileDocumentType } from "@buildwithflux/models";
export class FirestoreSharedDocumentRepository {
    db;
    constructor(db) {
        this.db = db;
    }
    /** @inheritdoc */
    createStream({ userUid, limit, documentTypeFilter = ProfileDocumentType.all, }) {
        let streamEnded = false;
        let lastRole = null;
        const fetchNextPage = (onSuccess, onError) => {
            if (streamEnded) {
                onSuccess([]);
                return () => {
                    // No-op
                };
            }
            let query = this.db.rolesCollectionGroup().where("data.user_uid", "==", userUid).limit(limit);
            if (lastRole) {
                query = query.startAfter(lastRole);
            }
            return query.onSnapshot(async (rolesSnapshot) => {
                lastRole = rolesSnapshot.docs[rolesSnapshot.docs.length - 1] ?? null;
                if (rolesSnapshot.docs.length === 0) {
                    streamEnded = true;
                    onSuccess([]);
                    return;
                }
                const toDocuments = rolesSnapshot.docs.map(async (roleDoc) => {
                    const projectId = roleDoc.ref.parent.parent?.id;
                    if (!projectId) {
                        return undefined; // Weird: maybe someone reused the name 'roles' for a different type of object? or bad data?
                    }
                    return await this.db.document(projectId).get();
                });
                const documents = (await Promise.all(toDocuments)).filter((p) => p !== undefined);
                onSuccess(documents
                    .map((doc) => doc.data()?.documentData)
                    .filter((doc) => {
                    if (!doc || doc.owner_uid === userUid) {
                        return false;
                    }
                    if (documentTypeFilter === ProfileDocumentType.project) {
                        return doc.belongs_to_part_uid === "";
                    }
                    else if (documentTypeFilter === ProfileDocumentType.component) {
                        return doc.belongs_to_part_uid !== "";
                    }
                    return true;
                }));
            }, onError);
        };
        const reset = () => {
            lastRole = null;
            streamEnded = false;
        };
        return {
            fetchNextPage,
            reset,
        };
    }
}
export function createFirestoreSharedDocumentRepository(db) {
    return new FirestoreSharedDocumentRepository(db);
}
//# sourceMappingURL=FirestoreSharedDocumentRepository.js.map